import { UsageProductTabs } from "../../pages/Usage/UsageProductTabs";
import styles from "../../pages/Usage/Usage.module.scss";
import { LookerCookielessFrame } from "@episerver/looker-dashboard";
import { OrganizationProduct } from "../../../domain/OrganizationProduct";
import { ADMINCENTER_PRODUCT_ID } from "../../../constants/constants";
import { Typography } from "@optimizely/axiom";
import React, { useState } from "react";
import { useSession } from "../../../hooks/useSession/useSession";
import { useAnalyticsTracking } from "../../../hooks/useAnalyticsTracking/useAnalyticsTracking";
import {
    ANALYTICS_EVENT_NAMES,
    ANALYTICS_FLOWS,
    ANALYTICS_TRACKED_COMPONENTS
} from "../../../constants/analytics-constants";
import { config } from "../../../config";

type ProductUsageDashboardsProps = {
    enableActivityLog?: boolean;
    organizationId?: string;
    products?: OrganizationProduct[];
};

export const ProductUsageDashboards = ({
    enableActivityLog = false,
    organizationId,
    products = []
}: ProductUsageDashboardsProps) => {
    const productsWithDashboards = products?.filter((p) =>
        enableActivityLog ? p.hasUsageDashboard : p.hasUsageDashboard && p.id !== ADMINCENTER_PRODUCT_ID
    );
    const [productId, setProductId] = useState<string>("");

    const { accessToken } = useSession();

    const { sendTrackEvent } = useAnalyticsTracking();

    if (!accessToken) {
        return null;
    }

    if (!productsWithDashboards?.length) {
        return (
            <div className="center">
                <Typography type="body">
                    None of your products currently have Usage & Billing enabled. Please contact your sales
                    representative for more information.
                </Typography>
            </div>
        );
    }

    const handleProductTab = ({ id }: { id: string }) => {
        setProductId(id);

        sendTrackEvent({
            name: ANALYTICS_EVENT_NAMES.VIEW_PRODUCT_USAGE_BILLING_DASHBOARD,
            component: ANALYTICS_TRACKED_COMPONENTS.USAGE_AND_BILLING_DASHBOARD,
            flow: ANALYTICS_FLOWS.USAGE_AND_BILLING,
            data: {
                dashboardOrganizationId: organizationId,
                selectedTabProductId: id,
                selectedTabProductName: productsWithDashboards.find((p) => p.id === id)?.name
            }
        });
    };

    return (
        <>
            <UsageProductTabs
                products={productsWithDashboards}
                productId={productId}
                onProductClick={handleProductTab}
            />
            {!!productId ? (
                <div className={styles["usage-page__no-data"]}>
                    <LookerCookielessFrame
                        env={config.APP_ENVIRONMENT}
                        organizationId={organizationId!!}
                        accessToken={accessToken}
                        productId={productId}
                        adminCenterProductId={ADMINCENTER_PRODUCT_ID}
                    />
                </div>
            ) : (
                <div className={styles["usage-page__no-data"]}>No available products to display usage data.</div>
            )}
        </>
    );
};
